import { createContext } from 'react';

import type { SidebarState, SidebarVariant } from './types';

interface SidebarContextType {
  state: SidebarState;
  toggle: () => void;
  setSidebarState: (state: SidebarState) => void;
  isCollapsible: boolean;
  variant: SidebarVariant;
}

export const SidebarContext = createContext<SidebarContextType | undefined>(
  undefined
);
